import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';



import { ConfirmDialogComponent } from '../../modules/shared/confirm-dialog/confirm-dialog.component';
import { SnackBarComponent } from '../../modules/shared/snack-bar/snack-bar.component';

@Injectable({ providedIn: "root" })
export class AlertService {
  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) { }

  public showConfirmMessage(
    message: string,
    snackBarConfig?: MatSnackBarConfig
  ) {
    let snackBarRef = this.snackBar.open(
      message,
      "X",
      Object.assign({ duration: 2000 }, snackBarConfig)
    );
    snackBarRef.onAction().subscribe(() => {
      snackBarRef.dismiss();
    });
  }

  public showErrorMessage(message: string, error: any, action?: string) {
    let errorMessage = error || "";
    if (error instanceof HttpErrorResponse) {
      errorMessage = error.message;
    }
    if (error && error.error && error.error.message) {
      errorMessage = error.error.message;
      if (typeof errorMessage != "string") {
        errorMessage = JSON.stringify(errorMessage);
      }
    }
    this.snackBar.openFromComponent(SnackBarComponent, {
       data: error, duration: 100000, verticalPosition: "top", panelClass: "error" });
  }

  public showConfirmDialog(
    title: string,
    message: string,
    okLabel: string = "Conferma",
    cancelLabel: string = "Annulla",
  ): Observable<any> {
    let dialogRef: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
      disableClose: false
    });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.confirmMessage = message;
    dialogRef.componentInstance.okButtonLabel = okLabel;
    dialogRef.componentInstance.cancelButtonLabel = cancelLabel;

    return dialogRef.afterClosed();
  }

  public showErrorDialog(
    title: string,
    message: string,
    okLabel: string = "Ok",
  ): Observable<any> {
    let dialogRef: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.confirmMessage = message;
    dialogRef.componentInstance.okButtonLabel = okLabel;
    dialogRef.componentInstance.showCancelButton = false;

    return dialogRef.afterClosed();
  }
}
